export const importTool = {
  selectModel: "Sélectionnez le type de données à importer ou exporter",
  export: {
    title: "Exporter - {{model}}",
    filters: "Filtres",
    filterBy: {
      assets: "Identifiant(s) d'actif",
      assetTypes: "Identifiant(s) de type d'actif",
      datasets: "Identifiant(s) de dataset",
      datasetTypes: "Identifiant(s) de type(s) de dataset",
      interventions: "Identifiant(s) d'intervention",
      locations: " Identifiant(s) de Localisation",
      organizations: "Identifiant(s) d'organisation",
      projects: "Identifiant(s) de projet",
      recommendations: "Identifiant(s) de recommandation",
      interventionTemplates: "Identifiant(s) de gabarit",
      interventionTemplate: "Identifiant(s) de gabarit",
    },
  },
  import: {
    selectFile: "Choisir un fichier",
    insertForm: {
      title: "Insertion - {{model}}",
      label: "Insérer des {{model}} depuis un fichier XLSX",
      submitButton: "Insérer des nouveaux {{model}}",
      exportTemplate: "Exporter le gabarit",
    },
    updateForm: {
      title: "Modification - {{model}}",
      label: "Modifier des {{model}} existants depuis un fichier XLSX",
      submitButton: "Modifier des {{model}} existants",
    },
    alerts: {
      errorTitle: "Une erreur dans la colonne `{{attribute}}`",
      errorTitle_other: "{{count}} erreurs dans la colonne `{{attribute}}`",
      ignoredHeadings: "Les colonnes suivantes seront ignorées:",
      invalidHeadings: "Les en-têtes du fichier sélectionné sont invalides.",
      rowInserted: "Une ligne a été insérée",
      rowInserted_other: "{{count}} lignes ont été insérées",
      rowInserted_zero: "Aucune ligne n'a été insérée",
      rowIgnored: "Une ligne a été ignorée",
      rowIgnored_other: "{{count}} lignes ont été ignorées",
      rowIgnored_zero: "Aucune ligne n'a été ignorée",
      rowUpdated: "Une ligne a été mise à jour",
      rowUpdated_other: "{{count}} lignes ont été mises à jour",
      rowUpdated_zero: "Aucune ligne n'a été mise à jour",
      successTitle: "Importation terminée avec succès !",
      validHeadings: "Les colonnes suivantes seront importées:",
    },
  },
};
